import axios from 'axios'

export default class Authenticater {

  static install = (Vue) => {
    Object.defineProperty(Vue.prototype, '$authenticater', {
      get() { return this.$root._authenticater}
    })
    Vue.mixin({
      beforeCreate() {
        this.$options.authenticater
        if (this.$options.authenticater)
        {
          this._authenticater = this.$options.authenticater
        }
      }
    })
  }

  //ログイン
  signin(username, password) {

    var url = "token/CreateToken"
    var params = {
      user_id: username,
      password: password
    }

    return new Promise((resolve, reject) => {
      //認証とトークン取得
      axios({
          method:'post',
          url: url,
          data:params,
          headers: {
            "Content-Type": "application/json",
          }
        })
       .then(response => {
        if (response.success) {
            resolve(response)
        } else {
            reject(response)
          }

        })
    })

  }

}